import(/* webpackMode: "eager" */ "/tmp/build_6ceda01a/apps/sales-pilot-sites/src/app/global-error.tsx");
